<template>
  <div class="app-body">
    <StoreLogTable source-type="make" query-type="receiver" :hide-query="['receiverName','status','orderCode']" :hide-buttons="['back','cancel']"
                   :hide-columns="['receiverName','receipt','receiveOptTime','receiveOptManName','price','count','backCount','transferCount']" :default-query-params="{status:10}"></StoreLogTable>
  </div>
</template>
<script>
/**
 * 工厂端-配件收货
 */
import StoreLogTable from '@/views/modules/erp/common/store-log-table.vue'

export default {
  components: { StoreLogTable },
  data () {
    return {}
  }
}
</script>
